module.exports = __webpack_public_path__ + "static/img/nocover.ee771978.png";